module.exports = __webpack_public_path__ + "static/img/9.b53d49d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/9.png
// module id = 0zZf
// module chunks = 0